<template>
  <div class="school-mystudy-view">
    <!-- 内容区域 (固定左右分栏布局：左侧可切换，右侧固定历史) -->
    <div class="mystudy-content" v-loading="loading">
      <div class="tab-layout-schedule">
        <!-- 左侧一列 (上面个人信息，下面任务与课表切换卡片) -->
        <div class="schedule-left-column">
          <!-- 个人信息卡片 -->
          <div class="user-info-card" v-if="user">
            <div class="user-info-inner">
              <div class="user-profile-wrap">
                <img
                  :src="
                    user.avatarUrl || require('@/assets/images/dfavatar.png')
                  "
                  class="user-avatar"
                />
                <div class="user-details">
                  <div class="user-name">
                    <span>{{ user.username || user.name }}</span>
                    <img
                      class="user-level-badge-img"
                      v-for="(lvl, idx) in activeEquityLevels"
                      :key="idx"
                      :src="require(`@/assets/images/${lvl}.png`)"
                    />
                  </div>
                  <div class="user-phone">
                    {{ maskPhone(user.phone) }}
                  </div>
                </div>
              </div>

              <!-- 学习统计 -->
              <div class="user-stats-wrap">
                <!-- 结业考试按钮：由 user.state 判断（等于2时在今日学习左侧展示） -->
                <div
                  v-if="user && user.state === 2"
                  class="stat-item stat-exam-btn cursor-pointer"
                  @click="onExamClick"
                >
                  <div class="stat-label">去考试</div>
                  <div
                    class="stat-value-wrap"
                    style="justify-content: center; align-items: center"
                  >
                    <img
                      src="@/assets/images/jxks.png"
                      class="stat-exam-icon"
                      alt="去考试"
                    />
                  </div>
                </div>
                <div v-if="user && user.state === 2" class="stat-divider"></div>

                <div class="stat-item">
                  <div class="stat-label">今日学习</div>
                  <div class="stat-value-wrap">
                    <span class="stat-num">{{
                      getTodayStudyTimeParts(user ? user.todayStudyTime : 0).num
                    }}</span>
                    <span class="stat-unit">{{
                      getTodayStudyTimeParts(user ? user.todayStudyTime : 0).unit
                    }}</span>
                  </div>
                </div>
                <div class="stat-divider"></div>
                <div class="stat-item">
                  <div class="stat-label">累计学习</div>
                  <div class="stat-value-wrap">
                    <template
                      v-if="
                        getTotalStudyTimeParts(user ? user.totalStudyTime : 0).hours > 0
                      "
                    >
                      <span class="stat-num">{{
                        getTotalStudyTimeParts(user ? user.totalStudyTime : 0).hours
                      }}</span>
                      <span class="stat-unit">h</span>
                      <span class="stat-num" style="margin-left: 4px">{{
                        getTotalStudyTimeParts(user ? user.totalStudyTime : 0).minutes
                      }}</span>
                      <span class="stat-unit">min</span>
                    </template>
                    <template
                      v-else-if="
                        getTotalStudyTimeParts(user ? user.totalStudyTime : 0).minutes > 0
                      "
                    >
                      <span class="stat-num">{{
                        getTotalStudyTimeParts(user ? user.totalStudyTime : 0).minutes
                      }}</span>
                      <span class="stat-unit">min</span>
                    </template>
                    <template v-else>
                      <span class="stat-num">{{
                        getTotalStudyTimeParts(user ? user.totalStudyTime : 0).seconds
                      }}</span>
                      <span class="stat-unit">s</span>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 下面的学习课表/学习任务切换板块 -->
          <div class="schedule-left-panel">
            <!-- 二级子导航切换 (移入左侧面板顶部) -->
            <div class="mystudy-tabs-container">
              <div
                class="mystudy-tab-item"
                :class="{ active: currentTab === 0 }"
                @click="changeTab(0)"
              >
                <span>学习任务</span>
                <div class="active-line" v-if="currentTab === 0"></div>
              </div>
              <div
                class="mystudy-tab-item"
                :class="{ active: currentTab === 1 }"
                @click="changeTab(1)"
              >
                <span>学习课表</span>
                <div class="active-line" v-if="currentTab === 1"></div>
              </div>
            </div>

            <!-- 学习任务子 Tab (仅学习任务展示，支持横向滑动与滚动) -->
            <div
              class="sub-task-tabs-wrapper"
              v-if="currentTab === 0 && taskList && taskList.length"
            >
              <div
                class="sub-task-scroll-container"
                ref="subTaskScroll"
                @wheel.passive="handleSubTaskWheel"
              >
                <div
                  class="sub-task-item"
                  v-for="task in taskList"
                  :key="task.id"
                  :class="{ active: selectedTaskId=== task.id }"
                  @click="selectTask(task.id)"
                >
                  <span class="sub-task-name textOverflowOne" :title="task.name">{{
                    task.name
                  }}</span>
                </div>
              </div>
            </div>

            <!-- Tab 0: 学习任务 (我的课程任务列表 - 横条卡片 + 进度条) -->
            <div class="left-tab-content animate-fade" v-if="currentTab === 0">
              <div class="task-courses-list" v-if="taskCourses.length">
                <div
                  class="task-course-card"
                  v-for="item in taskCourses"
                  :key="item.id"
                  @click="toCourseDetails(item)"
                >
                  <div class="course-card-left-wrap">
                    <div class="course-cover-wrap">
                      <img
                        :src="
                          item.cover ||
                          require('@/assets/images/communityBj.png')
                        "
                        class="course-cover"
                      />
                    </div>
                    <div class="course-info-wrap">
                      <div
                        class="course-title textOverflowOne"
                        :title="item.name"
                      >
                        {{ item.name }}
                      </div>
                      <div class="course-progress-row">
                        <span class="progress-label">进度:</span>
                        <div class="progress-bar-bg">
                          <div
                            class="progress-bar-fill"
                            :style="{ width: getPercent(item) + '%' }"
                          ></div>
                        </div>
                        <span class="progress-ratio">
                          {{ item.completedVideoCount || 0 }}/{{
                            item.totalVideoCount || 0
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="course-action-wrap">
                    <div class="continue-btn btnTransform">
                      {{ item.hasViewedVideo ? "继续学习" : "去学习" }}
                    </div>
                  </div>
                </div>
              </div>
              <None v-else />

              <!-- 学习任务分页 (单课程任务) -->
              <div class="pagination-wrap" v-if="taskTotal > 0">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="taskPage"
                  :page-size="taskSize"
                  :total="taskTotal"
                  @current-change="handleTaskPageChange"
                />
              </div>
            </div>

            <!-- Tab 1: 学习课表 (我的订阅课程包列表 - 横条卡片 + 元信息介绍，无需子Tab) -->
            <div class="left-tab-content animate-fade" v-else-if="currentTab === 1">
              <div class="task-courses-list" v-if="subscribedPackages.length">
                <div
                  class="task-course-card"
                  v-for="item in subscribedPackages"
                  :key="item.id"
                  @click="toPackageDetails(item)"
                >
                  <div class="course-card-left-wrap">
                    <div class="course-cover-wrap">
                      <img :src="item.cover" class="course-cover" />
                    </div>
                    <div class="course-info-wrap">
                      <div
                        class="course-title textOverflowOne"
                        :title="item.title"
                      >
                        {{ item.title }}
                      </div>
                      <!-- <div class="course-meta-row" style="width: 100%">
                        <div
                          class="meta-sub-item textOverflowOne"
                          :title="item.intro"
                          style="width: 100%"
                        >
                          <span>介绍：{{ item.intro || "" }}</span>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div class="course-action-wrap">
                    <div class="continue-btn btnTransform">
                      {{ item.hasViewedVideo ? "继续学习" : "去学习" }}
                    </div>
                  </div>
                </div>
              </div>
              <None v-else />

              <!-- 学习课表分页 (订阅课程包) -->
              <div class="pagination-wrap" v-if="packageTotal > 0">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="packagePage"
                  :page-size="packageSize"
                  :total="packageTotal"
                  @current-change="handlePackagePageChange"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧面板：固定展示学习历史时间轴  -->
        <div class="schedule-right-panel">
          <div class="history-glass-card">
            <div class="history-card-header">
              <span class="history-title">学习历史 ({{ historyTotal }})</span>
            </div>

            <div class="history-timeline-box" v-if="historyList.length">
              <!-- 时间轴节点 -->
              <div
                class="timeline-node-item"
                v-for="(item, index) in historyList"
                :key="index"
                @click="toCourseByName(item)"
              >
                <!-- 小绿圆点 -->
                <div class="timeline-dot"></div>

                <!-- 内容大框 -->
                <div class="node-content-wrap">
                  <div
                    class="node-title textOverflowOne"
                    :title="item.watchTime + ' ' + item.courseName"
                  >
                    <span class="node-time">{{
                      formatWatchTime(item.watchTime)
                    }}</span>
                    <span class="node-name">{{ item.courseName }}</span>
                  </div>
                  <div
                    class="node-video-name textOverflowOne"
                    v-if="item.videoName"
                    :title="item.videoName"
                    style="
                      font-size: 12px;
                      color: #8a9895;
                      margin-top: 2px;
                      margin-bottom: 2px;
                    "
                  >
                    课程名：{{ item.videoName }}
                  </div>
                  <div class="node-meta-row">
                    <div class="meta-sub-item">
                      <i class="el-icon-time"></i>
                      <span>{{ formatSeconds(item.watchDuration) }}</span>
                    </div>
                    <div class="meta-sub-item" v-if="item.courseClassifyName">
                      <i class="el-icon-folder-opened"></i>
                      <span>{{ item.courseClassifyName }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="history-none-box" v-else>
              <span class="none-text">暂无历史记录</span>
            </div>

            <!-- 右侧历史微型分页 -->
            <div class="history-pagination" v-if="historyTotal > historySize">
              <el-pagination
                small
                layout="prev, pager, next"
                :current-page="historyPage"
                :page-size="historySize"
                :total="historyTotal"
                :pager-count="5"
                @current-change="handleHistoryPageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import None from "@/components/none.vue";
import {
  studyTaskList,
  studyTaskCourseList,
  learningHistoryList,
  coursePackageSubscribedList,
} from "@/api/lx";

export default {
  name: "MyStudy",
  components: {
    None,
  },
  props: {
    user: {
      type: Object,
      default: null,
    },
    company: {
      type: Object,
      default: null,
    },
    initialStudyTaskId: {
      type: [String, Number],
      default: "",
    },
    initialTab: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    const routeTaskId = this.$route.query.studyTaskId;
    const initialTaskId =
      this.initialStudyTaskId !== undefined && this.initialStudyTaskId !== ""
        ? this.initialStudyTaskId
        : routeTaskId !== undefined
        ? routeTaskId
        : "";
    const routeTab = this.$route.query.myStudyTab;
    const initialCurrentTab =
      this.initialTab !== undefined && this.initialTab !== null
        ? Number(this.initialTab)
        : routeTab !== undefined
        ? Number(routeTab)
        : 0;

    return {
      currentTab: initialCurrentTab, // 0: 学习任务, 1: 学习课表
      loading: false,

      // 学习任务子分类列表（包含最前项“全部”）
      taskList: [{ id: "", name: "全部" }],
      selectedTaskId: initialTaskId, // 选中的任务ID，默认全部传空

      // 学习任务课程列表 (Tab 0)
      taskCourses: [],
      taskPage: 1,
      taskSize: 5,
      taskTotal: 0,

      // 学习历史时间轴 (固定在右侧)
      historyList: [],
      historyPage: 1,
      historySize: 5, // 配合 timeline 竖轴右边侧高度
      historyTotal: 0,

      // 学习课表已订阅课程包列表 (Tab 1)
      subscribedPackages: [],
      packagePage: 1,
      packageSize: 5,
      packageTotal: 0,
    };
  },
  watch: {
    initialStudyTaskId(newVal) {
      const val = newVal !== undefined && newVal !== null ? newVal : "";
      if (String(this.selectedTaskId) !== String(val)) {
        this.selectedTaskId = val;
        this.currentTab = 0;
        this.taskPage = 1;
        this.getTaskCourses();
        this.scrollToActiveSubTask();
      }
    },
    "$route.query.studyTaskId"(newVal) {
      const val = newVal !== undefined && newVal !== null ? newVal : "";
      if (String(this.selectedTaskId) !== String(val)) {
        this.selectedTaskId = val;
        this.currentTab = 0;
        this.taskPage = 1;
        this.getTaskCourses();
        this.scrollToActiveSubTask();
      }
    },
  },
  created() {
    // 页面载入时同时拉取历史记录、本人学习任务列表以及对应 Tab 的数据列表
    this.getLearningHistory();
    this.getStudyTasks();
    this.loadLeftData();
  },
  methods: {
    /**
     * 自动横向平滑滚动使当前激活的学习任务子 Tab 处于可视居中位置
     * @returns {void}
     */
    scrollToActiveSubTask() {
      this.$nextTick(() => {
        if (this.$refs.subTaskScroll) {
          const activeEl = this.$refs.subTaskScroll.querySelector(
            ".sub-task-item.active"
          );
          if (activeEl) {
            activeEl.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "center",
            });
          }
        }
      });
    },

    /**
     * 点击结业考试按钮，跳转考试页面
     * 提取用户 taskIds 或 studyTaskIds 数组中的第一个 taskId 作为参数传递给试卷页面
     * @returns {void}
     */
    onExamClick() {
      let taskId = "";
      if (this.user) {
        if (Array.isArray(this.user.taskIds) && this.user.taskIds.length > 0) {
          taskId = this.user.taskIds[0];
        } else if (
          Array.isArray(this.user.studyTaskIds) &&
          this.user.studyTaskIds.length > 0
        ) {
          taskId = this.user.studyTaskIds[0];
        }
      }
      this.$router.push({
        name: "examinationIndex",
        query: {
          taskId,
        },
      });
    },

    /**
     * 切换左侧 Tab 选项卡
     * @param {number} tab - 选中的选项卡索引 (0: 学习任务, 1: 学习课表)
     * @returns {void}
     */
    changeTab(tab) {
      if (this.currentTab === tab) return;
      this.currentTab = tab;
      this.loadLeftData();
    },
    /**
     * 根据当前主 Tab 加载对应的数据列表
     * @returns {void}
     */
    loadLeftData() {
      if (this.currentTab === 0) {
        this.getTaskCourses();
      } else {
        this.getSubscribedPackages();
      }
    },
    /**
     * 获取本人学习任务列表，并在最前面添加“全部”选项
     * @returns {void}
     */
    getStudyTasks() {
      studyTaskList()
        .then((res) => {
          const list = res.data || [];
          this.taskList = [{ id: "", name: "全部" }, ...list];
          this.scrollToActiveSubTask();
        })
        .catch((err) => {
          console.error("加载学习任务列表失败:", err);
          this.taskList = [{ id: "", name: "全部" }];
        });
    },
    /**
     * 切换选中的学习任务子 Tab
     * @param {string|number} taskId - 选中的任务 ID，为空字符串时表示全部
     * @returns {void}
     */
    selectTask(taskId) {
      if (String(this.selectedTaskId) === String(taskId)) return;
      this.selectedTaskId = taskId;
      this.taskPage = 1;
      this.getTaskCourses();
      this.scrollToActiveSubTask();
    },
    /**
     * 处理子 Tab 横向鼠标滚轮滚动
     * @param {WheelEvent} event - 滚轮事件对象
     * @returns {void}
     */
    handleSubTaskWheel(event) {
      if (this.$refs.subTaskScroll) {
        if (event.deltaY !== 0) {
          this.$refs.subTaskScroll.scrollLeft += event.deltaY;
        }
      }
    },
    /**
     * 加载课程任务列表 (分页)，支持 studyTaskId 筛选
     * @returns {void}
     */
    getTaskCourses() {
      this.loading = true;
      const params = {
        page: this.taskPage,
        size: this.taskSize,
      };
      if (this.selectedTaskId) {
        params.studyTaskId = this.selectedTaskId;
      }
      studyTaskCourseList(params)
        .then((res) => {
          const data = res.data || {};
          this.taskCourses = data.records || [];
          this.taskTotal = data.total || 0;
        })
        .catch((err) => {
          console.error("加载课程任务失败:", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 加载已订阅的课程包列表 (学习课表 Tab)
     * @returns {void}
     */
    getSubscribedPackages() {
      this.loading = true;
      coursePackageSubscribedList({
        page: this.packagePage,
        size: this.packageSize,
      })
        .then((res) => {
          const data = res.data || {};
          this.subscribedPackages = data.records || [];
          this.packageTotal = data.total || 0;
        })
        .catch((err) => {
          console.error("加载订阅课程包失败:", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 加载历史时间轴 (学习历史)
     * @returns {void}
     */
    getLearningHistory() {
      learningHistoryList({
        page: this.historyPage,
        size: this.historySize,
      })
        .then((res) => {
          const data = res.data || {};
          this.historyList = data.records || [];
          this.historyTotal = data.total || 0;
        })
        .catch((err) => {
          console.error("加载历史记录失败:", err);
        });
    },
    /**
     * 格式化日期，仅展示月日 MM-DD
     * @param {string} time - 完整时间字符串
     * @returns {string} 格式化后的时间 MM-DD
     */
    formatWatchTime(time) {
      if (!time) return "";
      const datePart = time.split(" ")[0];
      const parts = datePart.split("-");
      if (parts.length >= 2) {
        const mm = parts[parts.length - 2];
        const dd = parts[parts.length - 1];
        return `${mm}-${dd}`;
      }
      return datePart;
    },
    /**
     * 计算课程或课程包的学习进度百分比
     * @param {Object} item - 课程或课程包对象
     * @returns {number} 进度百分比 (0-100)
     */
    getPercent(item) {
      if (!item) return 0;
      // 兼容课程包的数据格式
      if (
        Object.prototype.hasOwnProperty.call(item, "totalCourseCount") ||
        Object.prototype.hasOwnProperty.call(item, "courseCount")
      ) {
        const total = item.totalCourseCount || item.courseCount || 0;
        if (!total) return 0;
        const completed = item.completedCourseCount || 0;
        return Math.min(Math.round((completed / total) * 100), 100);
      }
      // 兼容单门课程的数据格式
      const total = item.totalVideoCount || 0;
      if (!total) return 0;
      const completed = item.completedVideoCount || 0;
      return Math.min(Math.round((completed / total) * 100), 100);
    },
    /**
     * 秒数转换为 hh:mm:ss 格式
     * @param {number} seconds - 秒数
     * @returns {string} 格式化时间字符串
     */
    formatSeconds(seconds) {
      if (!seconds) return "00:00:00";
      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      const s = Math.floor(seconds % 60);
      return [
        h.toString().padStart(2, "0"),
        m.toString().padStart(2, "0"),
        s.toString().padStart(2, "0"),
      ].join(":");
    },
    /**
     * 任务课程分页变化
     * @param {number} page - 当前页码
     * @returns {void}
     */
    handleTaskPageChange(page) {
      this.taskPage = page;
      this.getTaskCourses();
    },
    /**
     * 学习课表订阅课程包分页变化
     * @param {number} page - 当前页码
     * @returns {void}
     */
    handlePackagePageChange(page) {
      this.packagePage = page;
      this.getSubscribedPackages();
    },
    /**
     * 历史分页变化
     * @param {number} page - 当前页码
     * @returns {void}
     */
    handleHistoryPageChange(page) {
      this.historyPage = page;
      this.getLearningHistory();
    },
    /**
     * 跳转至课程播放页，携带来源及当前选中的任务分类信息
     * @param {Object} item - 课程对象
     * @returns {void}
     */
    toCourseDetails(item) {
      const currentTask = this.taskList.find(
        (t) => String(t.id) === String(this.selectedTaskId)
      );
      const currentTaskName = currentTask ? currentTask.name : "全部";

      this.$router.push({
        path: "/school/details",
        query: {
          id: item.id,
          from: "myStudy",
          studyTaskId: this.selectedTaskId || "",
          studyTaskName: currentTaskName,
          myStudyTab: this.currentTab,
          classifyName: "全部",
          classifyId: "",
        },
      });
    },
    /**
     * 点击历史记录跳转至课程播放页
     * @param {Object} item - 历史记录对象
     * @returns {void}
     */
    toCourseByName(item) {
      const courseId = item.courseId;
      if (courseId) {
        const currentTask = this.taskList.find(
          (t) => String(t.id) === String(this.selectedTaskId)
        );
        const currentTaskName = currentTask ? currentTask.name : "全部";

        this.$router.push({
          path: "/school/details",
          query: {
            id: courseId,
            videoId: item.videoId || "",
            from: "myStudy",
            studyTaskId: this.selectedTaskId || "",
            studyTaskName: currentTaskName,
            myStudyTab: this.currentTab,
            classifyName: "全部",
            classifyId: "",
          },
        });
      }
    },
    /**
     * 进入课程包详情页
     * @param {Object} item - 课程包对象
     * @returns {void}
     */
    toPackageDetails(item) {
      this.$emit("to-package-details", item);
    },
    /**
     * 脱敏隐藏手机号中部四位
     * @param {string|number} phone - 原手机号码
     * @returns {string} 脱敏后的手机号
     */
    maskPhone(phone) {
      if (!phone) return "";
      const pStr = String(phone);
      if (pStr.length >= 7) {
        return pStr.substring(0, 3) + "****" + pStr.substring(pStr.length - 4);
      }
      return pStr;
    },
    /**
     * 格式化今日已看时长（小于1分钟显示秒，大于等于1分钟显示分钟）
     * @param {number} seconds - 秒数
     * @returns {Object} 包含 num (数值) 和 unit (单位) 的对象
     */
    getTodayStudyTimeParts(seconds) {
      const s = Number(seconds) || 0;
      if (s < 60) {
        return { num: s, unit: "s" };
      }
      return { num: Math.floor(s / 60), unit: "min" };
    },
    /**
     * 格式化今日已看时长为分钟
     * @param {number} seconds - 秒数
     * @returns {string} 描述分钟的字符串
     */
    formatTodayStudyTime(seconds) {
      if (!seconds) return "0";
      return Math.floor(seconds / 60).toString();
    },
    /**
     * 格式化累计观看时长为小时、分钟与秒对象形式
     * @param {number} seconds - 秒数
     * @returns {Object} 包含 hours, minutes 和 seconds 的对象
     */
    getTotalStudyTimeParts(seconds) {
      if (!seconds) return { hours: 0, minutes: 0, seconds: 0 };
      const s = Number(seconds) || 0;
      const hours = Math.floor(s / 3600);
      const minutes = Math.floor((s % 3600) / 60);
      const remSec = s % 60;
      return { hours, minutes, seconds: remSec };
    },
    /**
     * 格式化累计观看时长为小时与分钟组合形式
     * @param {number} seconds - 秒数
     * @returns {string} 格式化小时+分钟的字符串
     */
    formatTotalStudyTime(seconds) {
      if (!seconds) return "0";
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      return hours > 0 ? `${hours}h ${minutes}` : `${minutes}`;
    },
  },
  computed: {
    // 获取未过期的授权等级列表 (如 'L1', 'L2')
    activeEquityLevels() {
      if (!this.company || !Array.isArray(this.company.equityClassifyList)) {
        return [];
      }

      const now = Date.now();
      return this.company.equityClassifyList
        .filter((item) => {
          if (!item.equityClassifyName) return false;
          const nameUpper = String(item.equityClassifyName)
            .toUpperCase()
            .trim();
          if (!["L1", "L2", "L3", "L4"].includes(nameUpper)) {
            return false;
          }
          if (!item.endTime) return false;
          let end;
          // 判断是否为纯数字/数字字符串（即时间戳格式）
          if (!isNaN(item.endTime) && !isNaN(Number(item.endTime))) {
            end = new Date(Number(item.endTime));
          } else {
            // 普通的格式化日期字符串，兼容 iOS 替换 '-' 为 '/'
            end = new Date(String(item.endTime).replace(/-/g, "/"));
          }

          const isValid = end instanceof Date && !isNaN(end.getTime());
          const isExpired = isValid ? end.getTime() <= now : true;

          return isValid && !isExpired;
        })
        .map((item) => String(item.equityClassifyName).toUpperCase().trim());
    },
  },
};
</script>

<style lang="less" scoped>
.school-mystudy-view {
  width: 100%;
  min-height: 70vh;
  padding-bottom: 60px;
  box-sizing: border-box;
}

/* 个人信息卡片样式提取 */
.user-info-card {
  width: 100%;
}

.user-info-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(12px);
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(186, 202, 198, 0.25);
  box-sizing: border-box;
}

.user-profile-wrap {
  display: flex;
  align-items: center;
}

.user-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin-right: 16px;
  object-fit: cover;
}

.user-details {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-size: 20px;
  font-weight: 700;
  color: #191c1e;
  display: flex;
  align-items: center;
  gap: 8px;
}

.user-level-badge-img {
  width: 32px;
  height: 24px;
  object-fit: contain;
  vertical-align: middle;
}

.user-phone {
  font-size: 14px;
  color: #6b7a77;
  margin-top: 4px;
}

/* 学习统计 */
.user-stats-wrap {
  display: flex;
  gap: 32px;
  align-items: center;
}

.stat-item {
  text-align: right;
  display: flex;
  flex-direction: column;
}

.stat-exam-btn {
  cursor: pointer;
  transition: transform 0.2s ease;
  &:hover {
    transform: translateY(-1px);
    .stat-label {
      color: #00d8c3;
    }
  }
}

.stat-exam-icon {
  width: 22px;
  height: 22px;
  object-fit: contain;
}

.stat-label {
  font-size: 12px;
  color: #6b7a77;
  font-weight: 700;
}

.stat-value-wrap {
  margin-top: 4px;
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 2px;
}

.stat-num {
  font-size: 22px;
  font-weight: 800;
  color: #00d8c3;
}

.stat-unit {
  font-size: 10px;
  color: #6b7a77;
}

.stat-divider {
  width: 1px;
  height: 32px;
  background: rgba(186, 202, 198, 0.3);
}

.mystudy-content {
  width: 100%;
}

/* 经典左右分栏架构 */
.tab-layout-schedule {
  display: flex;
  gap: 24px;
  width: 100%;
  align-items: flex-start;
}

/* 左侧分栏纵向列容器 */
.schedule-left-column {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* 左侧面板：宽度自适应，内容可切换 */
.schedule-left-panel {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid rgba(186, 202, 198, 0.2);
  box-shadow: 0px 4px 16px rgba(0, 22, 26, 0.02);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-sizing: border-box;
}

/* 二级子导航切换 */
.mystudy-tabs-container {
  display: flex;
  align-self: stretch;
  padding-left: 8px;
  padding-right: 8px;
  border-bottom: 1px solid rgba(186, 202, 198, 0.2);
  gap: 32px;
}

.mystudy-tab-item {
  padding-top: 16px;
  padding-bottom: 16px;
  position: relative;
  font-size: 18px;
  color: #6b7a77;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
  user-select: none;

  &:hover {
    color: #00d8c3;
  }

  &.active {
    color: #00d8c3;
    font-weight: 700;
  }

  .active-line {
    width: 80px;
    height: 3px;
    left: -4px;
    bottom: -1px;
    position: absolute;
    background: #00d8c3;
    border-radius: 12px;
  }
}

/* 学习任务子 Tab 横向滑动容器 */
.sub-task-tabs-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
  margin-top: -8px;
}

.sub-task-scroll-container {
  display: flex;
  align-items: center;
  gap: 10px;
  overflow-x: auto;
  white-space: nowrap;
  padding: 4px 2px 8px 2px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  /* 自定义轻量美观滚动条 */
  &::-webkit-scrollbar {
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(186, 202, 198, 0.35);
    border-radius: 4px;
    &:hover {
      background: rgba(0, 216, 195, 0.5);
    }
  }
}

.sub-task-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 18px;
  border-radius: 20px;
  font-size: 13px;
  color: #5a6872;
  background: #f4f6f8;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
  user-select: none;
  flex-shrink: 0;
  max-width: 220px;
  border: 1px solid transparent;

  .sub-task-name {
    display: inline-block;
    max-width: 100%;
  }

  &:hover {
    color: #00d8c3;
    background: rgba(0, 216, 195, 0.08);
  }

  &.active {
    color: #ffffff;
    background: #00d8c3;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(0, 216, 195, 0.25);
    border-color: #00d8c3;
  }
}

.left-tab-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 课程卡片列表列表容器 */
.task-courses-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 大横条课程/课程包通用卡片样式 */
.task-course-card {
  width: 100%;
  padding: 24px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  border: 1px solid rgba(186, 202, 198, 0.3);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

  &:hover {
    background: #ffffff;
    border-color: #00d8c3;
    box-shadow: 0px 8px 24px rgba(0, 22, 26, 0.04);
    .continue-btn {
      background: #00c4b0;
      box-shadow: 0px 4px 10px rgba(0, 216, 195, 0.2);
    }
  }
}

.course-card-left-wrap {
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 1;
  min-width: 0;
}

.course-cover-wrap {
  width: 170px;
  height: 96px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  background: #f2f4f6;

  .course-cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.course-info-wrap {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.course-title {
  font-size: 18px;
  font-weight: 700;
  color: #333333;
  line-height: 28px;
}

/* 进度条样式 */
.course-progress-row {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 14px;
  color: #6b7a77;
}

.progress-label {
  font-weight: 400;
  color: #6b7a77;
  line-height: 20px;
}

.progress-bar-bg {
  width: 240px;
  height: 8px;
  background: #e6e8ea;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background: #00d8c3;
  border-radius: 12px;
  transition: width 0.3s ease;
}

.progress-ratio {
  font-family: Inter, sans-serif;
  font-weight: 400;
  color: #6b7a77;
  line-height: 20px;
}

/* 学习课表元数据样式 */
.course-meta-row {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: rgba(107, 122, 119, 0.8);
}

.meta-sub-item {
  display: flex;
  align-items: center;
  gap: 4px;
  i {
    font-size: 12px;
  }
}

.course-action-wrap {
  flex-shrink: 0;
  padding-left: 24px;
}

.continue-btn {
  width: 106px;
  height: 40px;
  box-sizing: border-box;
  padding: 0;
  background: #00d8c3;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  color: white;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.25s ease;
  line-height: 20px;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.package-action {
  color: #00d8c3;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: color 0.2s;
  flex-shrink: 0;
  &:hover {
    color: #00c4b0;
  }
}

/* 右侧面板：固定展示学习历史时间轴 */
.schedule-right-panel {
  width: 320px;
  flex-shrink: 0;
}

.history-glass-card {
  width: 100%;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(12px);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
}

.history-card-header {
  border-bottom: 1px solid rgba(186, 202, 198, 0.15);
  padding-bottom: 12px;

  .history-title {
    font-size: 16px;
    font-weight: 700;
    color: #333333;
  }
}

.history-timeline-box {
  position: relative;
  display: flex;
  flex-direction: column;
  padding-left: 8px;
  box-sizing: border-box;
}

.timeline-node-item {
  position: relative;
  padding-left: 28px;
  padding-bottom: 24px;
  z-index: 2;
  cursor: pointer;
  display: flex;
  flex-direction: column;

  /* 用伪元素作为每一项的左侧边框高度辅助线，以高度自适应伸缩 */
  &::before {
    content: "";
    position: absolute;
    left: 7px; /* 绿点圆心对齐线 */
    top: 16px; /* 从绿点圆心下方开始往下延展 */
    bottom: 0;
    width: 1px;
    background: rgba(186, 202, 198, 0.3);
  }

  /* 最后一项不需要向下延伸的线 */
  &:last-child {
    padding-bottom: 0;
    &::before {
      display: none;
    }
  }

  &:hover {
    .node-name {
      color: #00d8c3;
    }
    .timeline-dot {
      transform: scale(1.2);
      box-shadow: 0px 0px 8px rgba(0, 216, 195, 0.4);
    }
  }
}

.timeline-dot {
  position: absolute;
  left: 0;
  top: 1px; /* 对齐首行文字的垂直中心 */
  width: 15px;
  height: 15px;
  background: #00d8c3;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 50%;
  border: 2px white solid;
  transition: all 0.25s ease;
  box-sizing: border-box;
  z-index: 2;
}

.node-content-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.node-title {
  font-size: 13px;
  font-family: Inter, sans-serif;
  color: #191c1e;
  line-height: 18px;
  font-weight: 500;
}

.node-time {
  font-weight: 700;
  margin-right: 6px;
}

.node-name {
  transition: color 0.2s;
}

.node-meta-row {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 10px;
  color: rgba(107, 122, 119, 0.8);
}

.meta-sub-item {
  display: flex;
  align-items: center;
  gap: 4px;
  i {
    font-size: 11px;
  }
}

.history-none-box {
  padding: 30px 0;
  text-align: center;
  .none-text {
    font-size: 13px;
    color: #bacac6;
  }
}

.history-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid rgba(186, 202, 198, 0.1);
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  /* 解决 Element UI 在 small 模式下因 line-height 或 inline-block 造成的水平线不对齐及溢出问题 */
  /deep/ .el-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;

    .btn-prev,
    .btn-next {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 22px;
      line-height: 22px;
      min-width: 20px;
      padding: 0 2px;
      margin: 0 1px;
      vertical-align: middle;
    }

    .el-pager {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .el-pager li {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 22px;
      line-height: 22px;
      min-width: 20px;
      padding: 0 2px;
      margin: 0 1px;
      font-size: 12px;
      vertical-align: middle;
      box-sizing: border-box;
    }
  }
}

/* Micro animations */
.btnTransform {
  transition: transform 0.15s ease;
}
.btnTransform:active {
  transform: scale(0.95);
}

.hoverTransform {
  transition: transform 0.3s ease;
}
.hoverTransform:hover {
  transform: scale(1.04);
}

.textOverflowOne {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.textOverflowTwo {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
